import React, { useRef, useState } from "react";
import { BiCalendar } from "react-icons/bi";
import { GiHamburgerMenu } from "react-icons/gi";
import { HiHome } from "react-icons/hi";
import { PiUsersThreeBold } from "react-icons/pi";
import { TbZoomMoney } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import {
  ExercisesIcon,
  ProtocolsIcon,
  WorkoutsIcon,
} from "src/assets/static/icons";
import styled from "styled-components";
import StudentsModal from "../StudentsModal";

import { twMerge } from "tailwind-merge";
import "./styles.css";

const StyledDrawer = styled.div<{ open: boolean }>`
  bottom: 0;
  top: 0;
  display: flex;
  width: ${({ open }) => (open ? "250px" : "50px")};
  min-width: 40px;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  padding-bottom: 0.625rem;
  transition: all 300ms ease-in-out;

  /* Auto open on hover */
  &:hover {
    width: 250px !important;
  }
`;

interface DrawerButtonProps {
  icon: React.ReactNode;
  label: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  name?: string;
}

const DrawerButton: React.FC<DrawerButtonProps> = ({
  icon,
  label,
  onClick,
  name,
}) => (
  <button
    type="button"
    name={name}
    onClick={onClick}
    className={twMerge(
      `group flex w-full items-center gap-3 rounded-md px-2 py-2 transition-colors hover:bg-zinc-300 dark:hover:bg-zinc-700 ${"text-zinc-700 dark:text-zinc-200"}`,
      name && window.location.href.includes(name)
        ? "bg-zinc-300 dark:bg-zinc-750"
        : "",
    )}
  >
    <span
      className={twMerge(
        "flex items-center justify-center transition-transform",
        name && window.location.href.includes(name) ? "scale-100" : "scale-75",
      )}
    >
      {icon}
    </span>
    <span
      className="inline-block w-full overflow-hidden text-ellipsis whitespace-nowrap text-right text-sm font-semibold"
      style={{ minWidth: 0 }}
    >
      {label}
    </span>
  </button>
);

const DrawerMenu: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const [alunos, setAlunos] = useState(false);
  const [open, setOpen] = useState(false);

  function handle(e: React.MouseEvent<HTMLButtonElement>) {
    navigate(e.currentTarget.name);
  }

  return (
    <StyledDrawer
      className="bg-zinc group flex bg-zinc-100 p-1 shadow-lg dark:bg-zinc-800 sm:hidden"
      ref={ref}
      open={open}
    >
      <StudentsModal active={alunos} setActive={setAlunos} />

      {/* Botão Hamburguer/Chevron */}
      <button
        onClick={() => setOpen((prev) => !prev)}
        className="flex h-14 w-full justify-end pr-[10px] transition-opacity duration-300 hover:opacity-75"
      >
        <div className={`flex items-center justify-center`}>
          <GiHamburgerMenu className="text-black dark:text-white" size={22} />
        </div>
      </button>

      {/* Main Navigation */}
      <div className="flex w-full flex-1 flex-col justify-center">
        <nav className="flex flex-col gap-1">
          <DrawerButton
            icon={<HiHome size={25} />}
            label="Dashboard"
            onClick={handle}
            name="/dash"
          />
          <DrawerButton
            icon={<PiUsersThreeBold size={25} />}
            label="Alunos"
            onClick={() => setAlunos(true)}
          />
          <DrawerButton
            icon={<BiCalendar size={25} />}
            label="Agenda"
            onClick={handle}
            name="/calendar"
          />
          <DrawerButton
            icon={<TbZoomMoney size={25} />}
            label="Financeiro"
            onClick={handle}
            name="/checkout"
          />
        </nav>
      </div>

      {/* Templates */}
      <div className="flex w-full flex-1 flex-col justify-center">
        <nav className="flex w-full flex-col justify-between gap-1">
          <DrawerButton
            icon={<ProtocolsIcon size={25} />}
            label="Templates de Planos"
            onClick={handle}
            name="/tools/plans"
          />
          <DrawerButton
            icon={<WorkoutsIcon size={25} />}
            label="Templates de Treinos"
            onClick={handle}
            name="/tools/workout"
          />
          <DrawerButton
            icon={<ExercisesIcon size={25} />}
            label="Templates de Exercícios"
            onClick={handle}
            name="/tools/exercises"
          />
        </nav>
      </div>
    </StyledDrawer>
  );
};

export default DrawerMenu;
